module.exports = __webpack_public_path__ + "img/block_2.8c18c0d8.webp";